import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-closed-table',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './closed-table.component.html',
    styleUrl: './closed-table.component.scss'
})
export class ClosedTableComponent {}
